import { toNumber, toInteger } from 'lodash'
import { callOr } from '@/utils'

//using callOr directly results in 0 being turned to null
//if conversion isn't possible, returns the specified value
//difference between using null vs undefined for valueForInconvertivle. For data sent to BE, if set to null then null will be sent to BE, which runs a validaiton and can give an error for optional fields
//if set to undefined, the data will not be sent to BE, and will NOT result in an error for optional fields
export const stringToNumber = valueForInconvertible => x =>
  typeof x === 'number' ? x : callOr(toNumber, valueForInconvertible)(x)
export const stringToInteger = valueForInconvertible => x =>
  typeof x === 'number' ? x : callOr(toInteger, valueForInconvertible)(x)
